/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sandboxes_Metaachievementstitle2Inputs */

const id_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian`)
};

const ms_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pencapaian`)
};

const da_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievements`)
};

const de_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Errungenschaften`)
};

const en_us2_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Achievements`)
};

const es_es2_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logros`)
};

const es_mx2_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Logros`)
};

const fil_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Mga Achievement`)
};

const fr_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Succès`)
};

const it_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Risultati`)
};

const hu_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Teljesítmények`)
};

const nl_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestaties`)
};

const no_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestasjoner`)
};

const pl_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Osiągnięcia`)
};

const pt_br2_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquistas`)
};

const pt_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Conquistas`)
};

const ro_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Realizări`)
};

const fi_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Saavutukset`)
};

const sv_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Prestationer`)
};

const vi_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Thành tích`)
};

const tr_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Başarımlar`)
};

const cs_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Úspěchy`)
};

const bg_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Постижения`)
};

const ru_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Достижения`)
};

const uk_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Досягнення`)
};

const ar_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`الإنجازات`)
};

const hi_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`उपलब्धियाँ`)
};

const th_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`ความสำเร็จ`)
};

const ja_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`実績`)
};

const zh_cn2_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成就`)
};

const zh_hant1_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`成就`)
};

const ko_sandboxes_metaachievementstitle2 = /** @type {(inputs: Sandboxes_Metaachievementstitle2Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`도전 과제`)
};

/**
* | output |
* | --- |
* | "Achievements" |
*
* @param {Sandboxes_Metaachievementstitle2Inputs} inputs
* @param {{ locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
const sandboxes_metaachievementstitle2 = /** @type {((inputs?: Sandboxes_Metaachievementstitle2Inputs, options?: { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sandboxes_Metaachievementstitle2Inputs, { locale?: "id" | "ms" | "da" | "de" | "en-US" | "es-ES" | "es-MX" | "fil" | "fr" | "it" | "hu" | "nl" | "no" | "pl" | "pt-BR" | "pt" | "ro" | "fi" | "sv" | "vi" | "tr" | "cs" | "bg" | "ru" | "uk" | "ar" | "hi" | "th" | "ja" | "zh-CN" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_sandboxes_metaachievementstitle2(inputs)
	if (locale === "ms") return ms_sandboxes_metaachievementstitle2(inputs)
	if (locale === "da") return da_sandboxes_metaachievementstitle2(inputs)
	if (locale === "de") return de_sandboxes_metaachievementstitle2(inputs)
	if (locale === "en-US") return en_us2_sandboxes_metaachievementstitle2(inputs)
	if (locale === "es-ES") return es_es2_sandboxes_metaachievementstitle2(inputs)
	if (locale === "es-MX") return es_mx2_sandboxes_metaachievementstitle2(inputs)
	if (locale === "fil") return fil_sandboxes_metaachievementstitle2(inputs)
	if (locale === "fr") return fr_sandboxes_metaachievementstitle2(inputs)
	if (locale === "it") return it_sandboxes_metaachievementstitle2(inputs)
	if (locale === "hu") return hu_sandboxes_metaachievementstitle2(inputs)
	if (locale === "nl") return nl_sandboxes_metaachievementstitle2(inputs)
	if (locale === "no") return no_sandboxes_metaachievementstitle2(inputs)
	if (locale === "pl") return pl_sandboxes_metaachievementstitle2(inputs)
	if (locale === "pt-BR") return pt_br2_sandboxes_metaachievementstitle2(inputs)
	if (locale === "pt") return pt_sandboxes_metaachievementstitle2(inputs)
	if (locale === "ro") return ro_sandboxes_metaachievementstitle2(inputs)
	if (locale === "fi") return fi_sandboxes_metaachievementstitle2(inputs)
	if (locale === "sv") return sv_sandboxes_metaachievementstitle2(inputs)
	if (locale === "vi") return vi_sandboxes_metaachievementstitle2(inputs)
	if (locale === "tr") return tr_sandboxes_metaachievementstitle2(inputs)
	if (locale === "cs") return cs_sandboxes_metaachievementstitle2(inputs)
	if (locale === "bg") return bg_sandboxes_metaachievementstitle2(inputs)
	if (locale === "ru") return ru_sandboxes_metaachievementstitle2(inputs)
	if (locale === "uk") return uk_sandboxes_metaachievementstitle2(inputs)
	if (locale === "ar") return ar_sandboxes_metaachievementstitle2(inputs)
	if (locale === "hi") return hi_sandboxes_metaachievementstitle2(inputs)
	if (locale === "th") return th_sandboxes_metaachievementstitle2(inputs)
	if (locale === "ja") return ja_sandboxes_metaachievementstitle2(inputs)
	if (locale === "zh-CN") return zh_cn2_sandboxes_metaachievementstitle2(inputs)
	if (locale === "zh-Hant") return zh_hant1_sandboxes_metaachievementstitle2(inputs)
	return ko_sandboxes_metaachievementstitle2(inputs)
});
export { sandboxes_metaachievementstitle2 as "sandboxes.metaAchievementsTitle" }